import { For, Show, createResource } from "solid-js";
import { api } from "../api/client";
import PageHero from "../components/PageHero";
import Cell from "../components/tg/Cell";
import Section from "../components/tg/Section";
import { t } from "../i18n";
import { formatDistanceTotal, typeLabel } from "../lib/activity";
import { formatDuration } from "../lib/duration";

export default function StatsPage() {
  const [stats] = createResource(() => api.getMonthStats());

  return (
    <div>
      <PageHero title={t("STATS")} line={t("HERO_STATS_LINE")} />

      <Show when={stats.loading}>
        <p class="text-center text-[15px] text-ink-muted">{t("LOADING")}</p>
      </Show>

      <Show when={stats()}>
        {(s) => (
          <>
            <Section header={t("STATS")}>
              <Cell title={t("MONTH_WORKOUTS")} value={String(s().workoutCount)} />
              <Cell
                title={t("TOTAL_TONNAGE")}
                value={`${s().totalTonnage.toLocaleString()} ${t("KG")}`}
              />
              <Cell
                title={t("TOTAL_DURATION")}
                value={
                  s().totalDurationMinutes > 0
                    ? formatDuration(s().totalDurationMinutes)
                    : "—"
                }
              />
              <Cell
                title={t("AVG_DURATION")}
                value={
                  s().avgDurationMinutes > 0
                    ? formatDuration(Math.round(s().avgDurationMinutes))
                    : "—"
                }
              />
            </Section>

            <Show when={s().byType.length > 0}>
              <Section header={t("BY_TYPE")}>
                <For each={s().byType}>
                  {(row) => (
                    <Cell
                      title={typeLabel(row.type)}
                      subtitle={formatDistanceTotal(row.distanceMeters) || undefined}
                      value={`${row.count} · ${row.minutes > 0 ? formatDuration(row.minutes) : "—"}`}
                      leading={<span class={`stat-type-dot cal-mark--${row.type}`} />}
                    />
                  )}
                </For>
              </Section>
            </Show>

            <Section header={t("TOP_EXERCISES")}>
              <Show
                when={s().topExercises.length > 0}
                fallback={
                  <div class="px-4 py-6 text-center text-[15px] text-ink-muted">
                    {t("NO_DATA")}
                  </div>
                }
              >
                <For each={s().topExercises}>
                  {(ex, i) => (
                    <Cell
                      title={ex.name}
                      value={`×${ex.count}`}
                      leading={
                        <span class="text-[15px] tabular-nums text-ink-muted">
                          {i() + 1}
                        </span>
                      }
                    />
                  )}
                </For>
              </Show>
            </Section>

            <Section>
              <Cell href="/workouts" title={t("ALL_WORKOUTS")} chevron />
            </Section>
          </>
        )}
      </Show>
    </div>
  );
}
